import { useQuery } from "react-query";
import axios from "../services/Api/axiosConfigAuth";

const fetchMapUnitys = async (LatLon, CircleRadius) => {
  const config = { params: {
    lat: LatLon?.latitude ?? null,
    lon: LatLon?.longitude ?? null,
    distance: CircleRadius ?? null,
  }}
  const { data } = await axios.get(
    "/api/v1/unities/getunities",
    config
  );
  return data;
};

const useMapUnitys = (LatLon, CircleRadius) =>
  useQuery(["MapUnitys", LatLon, CircleRadius], () => fetchMapUnitys(LatLon, CircleRadius));
export default useMapUnitys;
